import {
  spacer8,
  spacer16,
  spacer24,
  spacer40,
  screenSmMax,
  screenMdMin,
} from '@spotify-internal/encore-foundation';
import styled from 'styled-components';
import { glueEaseInSoft } from '../../../vendor/Motion/variables';

const CARD_BOX_SHADOW = `0 ${spacer8} ${spacer16} 0 rgba(0, 0, 0, 0.07)`;
export const CardContainer = styled.div`
  margin-bottom: ${spacer24};
  position: relative;

  @media (max-width: ${screenSmMax}) {
    box-shadow: ${CARD_BOX_SHADOW};
  }

  @media (min-width: ${screenMdMin}) {
    margin-bottom: ${spacer40};

    &:hover {
      box-shadow: ${CARD_BOX_SHADOW};
      transition: box-shadow 0.3s ${glueEaseInSoft};
    }
  }
`;

export const AddsCardContainer = styled(CardContainer)`
  display: flex;
  flex-direction: column;
`;
export const CoverArt = styled.img`
  width: 144px;
  height: 144px;
  border-radius: 8px;
  position: relative;
`;

export const HeaderContainer = styled.div`
  position: relative;
`;

export const Header = styled.div<{ bgColor: string }>`
  background: linear-gradient(
    0deg,
    rgba(255, 255, 255, 1) 0%,
    rgba(255, 255, 255, 1) 33%,
    ${props => `${props.bgColor}`} 33%,
    ${props => `${props.bgColor}`} 100%
  );
  height: 144px;
  padding: 22px;
  margin-bottom: ${spacer24};
`;

export const Heading = styled.div`
  padding: ${spacer24} 22px 0 22px;
`;

export const AddsList = styled.ul`
  max-height: 360px;
  padding: 0 ${spacer24} 0 ${spacer24};
  margin-bottom: ${spacer24};
  overflow: auto;
  overflow-x: hidden;
  height: 100%;
  width: 100%;
  ::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 7px;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: rgba(0, 0, 0, 0.5);
    -webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
  }
`;

export const AddRow = styled.li`
  list-style: none;
  display: flex;
  justify-content: space-between;
  margin-bottom: ${spacer16};
  &:last-of-type {
    margin-bottom: 0;
  }
`;

export const AddCopy = styled.div`
  flex: 1;
`;

export const AddRowCoverArt = styled.img`
  height: 54px;
  width: 54px;
  max-width: 54px;
  display: inline-block;
  border-radius: 4px;
  flex: 1;
  margin-right: 16px;
`;
